import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getIconPath } from '@tcp/core/src/utils/utils';
import Image from '@tcp/core/src/components/common/atoms/Image';
import { PDP_SUB_LABELS, pdpSubLabels } from '@tcp/core/src/utils/labels/browse/PDP.labels';
import { getLabelFromCopyOrFromTranslation } from '@tcp/core/src/utils/labels/labelUtilty';
import {
  StyledBundleProductBadge,
  StyledBundleProductBadgeText,
} from '../styles/ProductBadge.styles';

function getInYourBagItemsCount({
  productId,
  inYourBagProducts = [],
  newFitProdIds = [],
  isSplittingExtendedSizesEnabled,
}) {
  if (isSplittingExtendedSizesEnabled && newFitProdIds.length > 0) {
    let totalQuantity = 0;

    const quantityMap = {};
    inYourBagProducts.forEach((item) => {
      // If the prodPartNo already exists in the map, add the quantity
      if (quantityMap[item.c_prodPartNo]) {
        quantityMap[item.c_prodPartNo] += item.quantity;
      } else {
        // Otherwise, initialize it with the current quantity
        quantityMap[item.c_prodPartNo] = item.quantity;
      }
    });

    totalQuantity = newFitProdIds.reduce((total, prodId) => {
      return total + (quantityMap[prodId] || 0);
    }, 0);

    return totalQuantity;
  }
  if (productId && inYourBagProducts) {
    return inYourBagProducts
      ?.map((prod) => {
        const prodPartNo = prod?.c_prodPartNo?.split('_')[0];
        return {
          quantity: prod.quantity,
          prodPartNo,
        };
      })
      ?.reduce((acc, product) => {
        const id = productId?.split('_')[0];
        if (product.prodPartNo === id) {
          return acc + product.quantity;
        }
        return acc;
      }, 0);
  }
  return 0;
}

const ProductBadge = ({
  productId,
  inYourBagProducts,
  newFitProdIds,
  isSplittingExtendedSizesEnabled,
}) => {
  const inBagLabel = getLabelFromCopyOrFromTranslation(
    `${PDP_SUB_LABELS}.lbl_in_bag`,
    pdpSubLabels
  );

  const [inYourBagCount, setInYourBagCount] = useState(
    getInYourBagItemsCount({
      productId,
      inYourBagProducts,
      newFitProdIds,
      isSplittingExtendedSizesEnabled,
    })
  );

  useEffect(() => {
    setInYourBagCount(
      getInYourBagItemsCount({
        productId,
        inYourBagProducts,
        newFitProdIds,
        isSplittingExtendedSizesEnabled,
      })
    );
  }, [productId, inYourBagProducts, newFitProdIds, isSplittingExtendedSizesEnabled]);

  const text = `${inYourBagCount} ${inBagLabel}`;

  return (
    <>
      {inYourBagCount > 0 ? (
        <StyledBundleProductBadge>
          <Image
            aria-hidden={true}
            alt="success-icon"
            className="items-in-bag-success-icon"
            src={getIconPath('circle-check-fill-green')}
          />
          <StyledBundleProductBadgeText fontFamily="secondary" component="span" fontWeight="bold">
            {text}
          </StyledBundleProductBadgeText>
        </StyledBundleProductBadge>
      ) : null}
    </>
  );
};

ProductBadge.propTypes = {
  productId: PropTypes.string,
  inYourBagProducts: PropTypes.arrayOf(
    PropTypes.shape({
      quantity: PropTypes.number,
      c_prodPartNo: PropTypes.string,
    })
  ),
};

ProductBadge.defaultProps = {
  productId: '',
  inYourBagProducts: [
    {
      quantity: 0,
      c_prodPartNo: '',
    },
  ],
};

export default ProductBadge;
